import React from 'react';
import Typography from "@material-ui/core/Typography/Typography";
import Grid from "@material-ui/core/Grid/Grid";
import {withStyles} from "@material-ui/core/styles/index";
import Button from "@material-ui/core/Button/Button";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import copyToClipboard from 'copy-to-clipboard';
import IconButton from "@material-ui/core/IconButton/IconButton";

import copyIcon from '../iconCopy.svg';
import {styles, variables} from "../styles";
import {requestPubnubApiGET, requestPubnubApiPOST, withCredentials} from "../apiClient";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import ErrorSnackbar from "./ErrorSnackbar";

class DeployTutorialApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitErrorText: '',
      showErrorSnackbar: false,
      disabled: false,
      subscribeKey: '',
      publishKey: '',
      copyPublishKeyText: 'Copy',
      copySubscribeKeyText: 'Copy',
    };
  }

  handleError = error => {
    if (error.response) {
      this.setState({
        submitErrorText: error.response.body.message || error.response.body.error,
        showErrorSnackbar: true,
        disabled: false,
      });
    } else {
      this.setState({
        submitErrorText: 'Something unexpected happen, please try again later',
        showErrorSnackbar: true,
        disabled: false,
      });
    }
  };

  deployTutorialApp = () => {
    this.setState({disabled: true});
    return withCredentials(requestPubnubApiGET)('/accounts', {query: {user_id: this.props.userId}}).then(response => {
      const accountId = response.body.result.accounts[0].id;
      return withCredentials( requestPubnubApiPOST)(
        '/apps',
        {
          body: {
            owner_id: accountId,
            name: 'PubSub Quickstart',
          }
        }
      ).then(response => {
        return withCredentials(requestPubnubApiGET)(`/apps/${response.body.result.id}`).then(response => {
          const publishKey = response.body.result.keys[0].publish_key;
          const subscribeKey = response.body.result.keys[0].subscribe_key;
          this.setState({
            publishKey,
            subscribeKey,
            disabled: false,
          })
        })
      })
    }).catch(error => {
      this.handleError(error);
    })
  };

  copyToClipboard = (content, pubsub) => {
    copyToClipboard(content);
    if (pubsub === 'sub') {
      this.setState({copySubscribeKeyText: 'Copied!'});
      setTimeout(() => this.setState({copySubscribeKeyText: 'Copy'}), 3000);
    } else {
      this.setState({copyPublishKeyText: 'Copied!'});
      setTimeout(() => this.setState({copyPublishKeyText: 'Copy'}), 3000);
    }
  };

  render() {
    if ((this.state.subscribeKey && this.state.publishKey) || (this.props.appKey.publish_key && this.props.appKey.subscribe_key)) {
      return (
        <div>
          <Grid container spacing={8}>
            <Grid item xs={2}>
              <img src="pubnub.png" alt="PubNub" style={{width: "100px"}}/>
            </Grid>
          </Grid>
          <Grid container spacing={8} alignItems="center" justify="center">
            <Grid item xs={12} sm={10} md={8} lg={6}>
              <Grid item xs>
                <Typography variant="body1" gutterBottom className={this.props.classes.successBody}
                            style={{margin: '40px 0 25px'}}>
                  Here are your Demo Pub/Sub keys:
                </Typography>
                <Grid container direction="row" alignItems="center" justify="center">
                  <Grid item xs>Publish Key</Grid>
                  <Grid item xs style={{textAlign: 'right'}}>
                    <pre id="publishKey">{this.state.publishKey || this.props.appKey.publish_key}</pre>
                  </Grid>
                  <Grid item xs>
                    <Tooltip title={this.state.copyPublishKeyText} placement="top">
                      <IconButton onClick={() => this.copyToClipboard(this.state.publishKey || this.props.appKey.publish_key, 'pub')}>
                        <img src={copyIcon} alt="Copy" style={{width: '15px', height: '15px'}}/>
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center">
                  <Grid item xs>Subscribe Key</Grid>
                  <Grid item xs style={{textAlign: 'right'}}>
                    <pre id="subscribeKey">{this.state.subscribeKey || this.props.appKey.subscribe_key}</pre>
                  </Grid>
                  <Grid item xs>
                    <Tooltip title={this.state.copySubscribeKeyText} placement="top">
                      <IconButton onClick={() => this.copyToClipboard(this.state.subscribeKey || this.props.appKey.subscribe_key, 'sub')}>
                        <img src={copyIcon} alt="Copy" style={{width: '15px', height: '15px'}}/>
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      )
    }
    return (
      <Grid container spacing={8}>
        <Grid item xs>
          <img src="pubnub.png" alt="PubNub" style={{width: "100px"}}/>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" gutterBottom className={this.props.classes.successTitle}>
            Welcome!
          </Typography>
          <Typography variant="body1" gutterBottom className={this.props.classes.successBody}>
            Create your <span style={{fontWeight: 'bold', color: variables.RED_CARDINAL}}>FREE</span> Pub/Sub API keys
            by clicking below:
          </Typography>
          <Typography variant="body1" gutterBottom className={this.props.classes.successBody}>
            <Button
              id="ctaButton"
              className={this.props.classes.ctaButton}
              onClick={this.deployTutorialApp}
              variant="contained"
              color="primary"
              disabled={this.state.disabled}
            >
              {this.state.disabled ?
                <CircularProgress size={21}
                                  className={this.props.classes.buttonCircularProgress}/> : 'Create Pub/Sub API keys'}
            </Button>
          </Typography>
          <Typography variant="body1" gutterBottom className={this.props.classes.successBody}>
            You can access your Keys at any time on your PubNub dashboard.
          </Typography>
        </Grid>
        <Grid item xs/>
        <ErrorSnackbar
          message={this.state.submitErrorText}
          open={this.state.showErrorSnackbar}
          onClose={this.closeSnackbar}
        />

      </Grid>
    )
  }
};

export default withStyles(styles)(DeployTutorialApp);


// WEBPACK FOOTER //
// ./src/componentes/DeployTutorialApp.js